import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PushNotificationState , PUSH_NOTIFICATIONS_REDUCER_KEY } from "./push-notification.reducer";

export const selectPushNotificationState = createFeatureSelector<PushNotificationState>(PUSH_NOTIFICATIONS_REDUCER_KEY);

export const selectDeviceToken = createSelector(selectPushNotificationState, state => state.currentDeviceToken);